import React from 'react';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0f1a2e] via-[#1a2744] to-[#0d1421]"></div>
      
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#c23a4a] rounded-full filter blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#1a2744] rounded-full filter blur-[120px]"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Logo */}
        <div className="mb-8">
        <img 
            src="/images/logo.jpeg" 
            alt="Vinayak Enterprise industrial pipeline contractor logo in Vadodara" 
            className="h-28 w-28 mx-auto rounded-xl shadow-2xl shadow-[#c23a4a]/20 object-cover"
            width="112"
            height="112"
            decoding="async"
            fetchPriority="high"
            data-testid="hero-logo"
          />
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" data-testid="hero-title">
          Industrial Pipeline Services in <span className="text-[#c23a4a]">Vadodara</span>
        </h1>
        <p className="text-xl sm:text-2xl text-[#c23a4a] mb-4 font-medium" data-testid="hero-subtitle">
          Vinayak Enterprise | Infrastructure Services Gujarat
        </p>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto mb-10" data-testid="hero-description">
          We deliver process pipeline, utility pipeline, fabrication, insulation, valve supply,
          and industrial maintenance services for plants and infrastructure projects across
          Vadodara and Gujarat.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/services"
            onClick={(event) => {
              event.preventDefault();
              scrollToSection('services');
            }}
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#c23a4a] hover:bg-[#a83240] text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg shadow-[#c23a4a]/30"
            data-testid="explore-services-btn"
          >
            Explore Services <ArrowRight size={20} />
          </a>
          <a
            href="/contact"
            onClick={(event) => {
              event.preventDefault();
              scrollToSection('contact');
            }}
            className="inline-flex items-center gap-2 px-8 py-4 border-2 border-[#c23a4a] text-[#c23a4a] hover:bg-[#c23a4a] hover:text-white font-semibold rounded-lg transition-all duration-300"
            data-testid="contact-us-btn"
          >
            Request a Quote
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#c23a4a]/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-[#c23a4a] rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
